import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const links = [
  { label: "Simulateurs", href: "#simulateurs" },
  { label: "Étapes", href: "#etapes" },
  { label: "Guides", href: "#guides" },
  { label: "Contact", href: "#newsletter" },
];

export default function Header() {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-40 bg-bone/90 backdrop-blur-md border-b border-border"
      data-testid="header-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a href="#" className="font-sub font-extrabold tracking-tight text-2xl" data-testid="header-logo">
          construire<span className="text-terra">maison</span>.net
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-sub text-sm uppercase tracking-[0.15em] text-ink/70 hover:text-ink transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#simulateurs"
          data-testid="header-cta"
          className="group inline-flex items-center gap-2 bg-terra text-white font-sub text-sm font-medium px-5 py-2.5 rounded-full hover:bg-terra-dark hover:-translate-y-0.5 transition-[background-color,transform] duration-200"
        >
          Commencer
          <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </a>
      </div>
    </motion.header>
  );
}
